import type { SVGProps } from 'react';

export const ScoreTarget = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.59941 16.7992C13.5759 16.7992 16.7994 13.5757 16.7994 9.59922C16.7994 5.62277 13.5759 2.39922 9.59941 2.39922C5.62296 2.39922 2.39941 5.62277 2.39941 9.59922C2.39941 13.5757 5.62296 16.7992 9.59941 16.7992ZM9.59854 13.9483C12.001 13.9483 13.9485 12.0008 13.9485 9.59834C13.9485 7.1959 12.001 5.24834 9.59854 5.24834C7.1961 5.24834 5.24854 7.1959 5.24854 9.59834C5.24854 12.0008 7.1961 13.9483 9.59854 13.9483Z"
        fill="currentColor"
      />
      <path
        d="M10.8006 4.7998L10.8006 -0.000196457H8.40059V4.7998H10.8006Z"
        fill="currentColor"
      />
      <path
        d="M0 8.40039L4.8 8.40039V10.8004H0L0 8.40039Z"
        fill="currentColor"
      />
      <path
        d="M19.1994 8.40039L14.3994 8.40039V10.8004H19.1994L19.1994 8.40039Z"
        fill="currentColor"
      />
      <path
        d="M10.8006 19.1992L10.8006 14.3992H8.40059V19.1992L10.8006 19.1992Z"
        fill="currentColor"
      />
      <path
        d="M9.33771 7.44178C9.61427 7.78667 9.97071 8.05896 10.3761 8.2353C10.7816 8.41163 11.2237 8.48699 11.6645 8.45459C11.6823 8.45258 11.7002 8.45584 11.7163 8.46363C11.7323 8.47142 11.7459 8.48373 11.7552 8.49905C11.7645 8.51437 11.7693 8.53195 11.7688 8.54979C11.7685 8.56762 11.763 8.58496 11.7532 8.60003C11.5108 8.96978 11.3621 9.39304 11.3196 9.83313C11.2772 10.2732 11.3422 10.7171 11.5095 11.1263C11.5161 11.1426 11.5181 11.1602 11.515 11.1775C11.512 11.1948 11.5045 11.2109 11.4929 11.224C11.4814 11.237 11.4663 11.2466 11.4495 11.2516C11.4327 11.2566 11.4148 11.2569 11.398 11.2524C10.971 11.1356 10.5218 11.1248 10.0895 11.2205C9.65722 11.3162 9.25481 11.5156 8.91696 11.8017C8.90339 11.8128 8.88707 11.8201 8.86973 11.8226C8.8524 11.8251 8.83482 11.8226 8.81874 11.8155C8.80266 11.8085 8.78885 11.7975 8.7788 11.7829C8.76875 11.7683 8.76298 11.7517 8.76172 11.7342C8.74037 11.2928 8.61201 10.863 8.38769 10.4822C8.16338 10.1014 7.84989 9.78088 7.47436 9.54828C7.45954 9.53898 7.44773 9.52567 7.43994 9.50985C7.43216 9.49402 7.42914 9.47669 7.43065 9.4591C7.43241 9.44177 7.43869 9.42494 7.44924 9.41113C7.45979 9.39706 7.47411 9.38626 7.49018 9.37998C7.9039 9.22349 8.2734 8.96878 8.5668 8.63771C8.86019 8.30664 9.06843 7.909 9.17368 7.47946C9.1777 7.46238 9.18649 7.44706 9.19905 7.43475C9.21161 7.42244 9.22718 7.4139 9.24401 7.41013C9.26109 7.40636 9.27893 7.40712 9.29525 7.41289C9.31183 7.41867 9.32665 7.42822 9.33771 7.44178Z"
        fill="currentColor"
      />
    </svg>
  );
};
